/** Created by azhou on 2019/3/8.*/
<template>
    <!-- 采购商企业资质 -->
    <div class="blank_space ">
      <el-alert :title="TitleMsg" type="success" :class="BasicInfo.edit_status==1&&'red'" :closable="false" center/>
      <div class="TravelAgency">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="mt-4 mb-3">
            <div class="d-start-start mb-3 mt-4">
              <left-text leftText="营业执照"/>
              <upload-image @fileChange="(imgs)=>{verifyImg = imgs[0];}"
                            :existImgs="StoreBasicInfo.certpic" :maxLength="1" :editMode="showEditModel"/>
                            
            </div>
            <div class="d-flex mb-3 mt-4">
              <div class="d-start-start">
                <left-text leftText="消防验收合格证"/>
                <upload-image @fileChange="(imgs)=>{certfire = imgs[0];}"
                              :existImgs="certfire" :maxLength="1" :editMode="showEditModel"/>
              </div>
              <div class="d-start-start">
                <left-text leftText="卫生许可证" class="ml-4"/>
                <upload-image @fileChange="(imgs)=>{certheal = imgs[0];}"
                              :existImgs="certheal" :maxLength="1" :editMode="showEditModel"/>
              </div>
              <div class="d-start-start">
                <left-text leftText="特种行业许可证 " class="ml-4"/>
                <upload-image @fileChange="(imgs)=>{certspec = imgs[0];}"
                              :existImgs="certspec" :maxLength="1" :editMode="showEditModel"/>
              </div>
            </div>
          </div>
          <el-button @click="reVerify" class="mt-4 w-50 btn-login" >提交资质</el-button>
        </el-col>
      </el-row>
      <el-dialog title="提交信息" :visible.sync="showConfirmPanel" width="480px" center id="loadConfirm">
        <Verify-Info-Text :priceArrs='Informationtext'/>
        <div slot="footer">
          <el-button size="small" type="primary" @click="showConfirmPanel = false">返回</el-button>
        </div>
      </el-dialog>
      </div>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapActions } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import VerifyInfoText from './Comps/VerifyInfoText.vue'
  export default {
    name: 'VerifyInfo',
    components: {VerifyInfoText},
    computed: {
      ...mapState(['StoreBasicInfo','Informationtext']),
      ...mapGetters(['storeInfo','isGroup','userInfo']),
      storeId() { return this.$route.query.store},
      TitleMsg() {
        if (this.BasicInfo.edit_status==1) return '认证信息已提交，请耐心等待...'
        else return '变更认证信息需要提交申请，待后台审核通过后方能变更成功。'
      },
    },
    data() {
      return {
        title: '',                    //门店名称
        showEditModel:true,        //编辑认证信息模式
        showConfirmPanel:false,
        snp:false,
        Model:true,
        reason: '',
        otherReason: '',
        longitude:'',
        latitude:'',
        reasonsArr: [
          '单位名称变更',
          '营业执照有修改',
          '人事调动',
          '手动填写其他原因'
        ],                   //重新认证的理由
        lonLatInfo:{},          //门店经纬度信息，BMap组件不直接修改BasicInfo中的经纬度值，会引起重复渲染maker标记点
        BasicInfo: {},
        addressDetail: '',
        pcd: '',
        Title: '',
        weit:0,//判断是否微调
        verifyImg: '',                //重新上传的营业执照照片
        certfire	: '',               //消防验收合格证
        certheal	: '',               //卫生许可证
        certspec: '',                 //特种行业许可证
      }
    },
    watch: {
      StoreBasicInfo (newVal) {
        // this.BasicInfo = newVal;
        // this.verifyImg = this.BasicInfo.certpic;
        this.initStoreInfo()
      },
      // storeId(newVal) {
      //   console.log('storeId',newVal) 
      //   this.getInfo(newVal);
      // }
    },
    created () {
    //   this.initStoreInfo()
    //   this.getInfo(this.storeId);
    },
    methods:{
      ...mapActions(['setStoreVerify','logout','information','getStoreInfo']),
      /*获取门店信息*/
      getInfo(storeId) {
        console.log(storeId);
        let data = {};
        //管理员需要获取设置签约身份、门店负责人的数组
        if (this.isAdmin) {
          data.is_get_contract_arr = '1';
          data.is_get_admin_user_arr = '1';
        }
        if(storeId) data.store_id = storeId;
        this.getStoreInfo(data);
      },
      /*查看编辑认证信息*/
      editinformation(){
        this.showConfirmPanel = !this.showConfirmPanel;
        this.information();
      },
      initStoreInfo () {
        this.BasicInfo = {...this.StoreBasicInfo}
        this.addressDetail = this.BasicInfo.address
        this.title = this.BasicInfo.title;
        // this.title = this.StoreBasicInfo.title;
        this.verifyImg = this.StoreBasicInfo.certpic;
        this.certfire = this.StoreBasicInfo.certfire;
        this.certheal = this.StoreBasicInfo.certheal;
        this.certspec = this.StoreBasicInfo.certspec;
        this.lonLatInfo.lng= this.BasicInfo.longitude;
        this.lonLatInfo.lat=this.BasicInfo.latitude;
        this.pcd = this.BasicInfo.province_name + '省' + this.BasicInfo.city_name + '市' + this.BasicInfo.district_name
      },
      /**点击编辑 */
      confirmSubmit(){
        this.showEditModel = !this.showEditModel;
        //点返回更新数据
        if(!this.showEditModel){
          this.initStoreInfo();
        }
      },
      position(e){
        this.lonLatInfo=e;
        this.longitude = e.lng; this.latitude = e.lat;
        this.storePoint[0].nid=false
      },
      /*获取省市区id和name*/
      getCityInfo (info) {
        console.log(info);
        for (let key in info) {
          this.$set(this.BasicInfo,key,info[key]);
        }
      },
      validateForm() {
        if (!this.title) return {code: false, msg: '名称不得为空'};
        if (!this.verifyImg) return {code: false, msg: '请上传营业执照'};
        if (!this.reason) return {code: false, msg: '请选择修改认证信息的理由'};
        if (this.reason === '手动填写其他原因' && !this.otherReason) return {code: false, msg: '请填写其他理由'};
        return {code: true, msg: '验证通过'}
      },
      reVerify() {
        let result = this.validateForm();
        this.BasicInfo.title = this.title
        if (result.code) {
          let msg = this.isGroup ? '确定为该门店提交认证信息么？' : '认证信息提交申请期间，不影响原认证信息的使用，待通过后会更新原认证信息。确认提交么？';
          this._confirm(msg, async () => {
            //处理基本信息中的营业执照
            this.verifyImg = (await UploadImages(this.verifyImg))[0];
            this.certfire = (await UploadImages(this.certfire))[0];
            this.certheal = (await UploadImages(this.certheal))[0];
            this.certspec = (await UploadImages(this.certspec))[0];
            this.BasicInfo.longitude = this.lonLatInfo.lng;
            this.BasicInfo.latitude = this.lonLatInfo.lat;
            this.setStoreVerify({
              data:{
                province:this.BasicInfo.province,
                province_name:this.BasicInfo.province_name,
                city:this.BasicInfo.city,
                city_name:this.BasicInfo.city_name,
                district:this.BasicInfo.district,
                district_name:this.BasicInfo.district_name,
                address:this.BasicInfo.address,
                title: this.BasicInfo.title,
                latitude: this.BasicInfo.latitude,
                longitude: this.BasicInfo.longitude,
                certpic: this.verifyImg,
                certfire: this.certfire,
                certheal: this.certheal,
                certspec: this.certspec,
                reason: this.reason === '手动填写其他原因' ? this.otherReason : this.reason,
                storeId:this.storeId
              },
              verify: '3',
              successFun:() => {
                this.showEditModel = !this.showEditModel;
                this.Model=!this.Model;
                this.getStoreInfo();
                this.initStoreInfo();
                // this.$router.back();
                // if (!this.isGroup) this.logout(false);
                // else this.$router.back();
              }
            })
          });
        } else this._alert(result.msg,null,'error')
      }
    }
  }
</script>
<style scoped>
.blank_space{
  background-color: #fff;
  padding: 30px !important; 
}
.lies{
  margin-top: 10px;
}
.lies p{
  margin-top: 10px;
}
.red{
  color: red;
}
.list-text{
  color: #999;
}
.TravelAgency{
    width: 1000px;
    margin: 0 auto;
}
</style>
